import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Badge extends React.PureComponent {
    static propTypes = {
        /** Number to show inside the pill */
        children: PropTypes.number,

        /** The largest number to show in the pill. Any values larger than the max are shown as the max + */
        max: PropTypes.number,

        /** The visual appearance of the pill */
        appearance: PropTypes.oneOf(['default', 'primary', 'important', 'info'])
    };

    static defaultProps = {
        children: 0,
        max: 99,
        appearance: 'default'
    };

    renderFormattedNumber() {
        let { children, max } = this.props;
        let numberToShow = 0;
        let suffix = '';

        if (typeof children !== 'number') {
            return numberToShow;
        }

        if (children < 0) {
            children = 0;
        }

        if (max < 0) {
            max = 0;
        }

        if (max && max < children) {
            numberToShow = max;
            suffix = '+';
        }
        else {
            numberToShow = children;
        }

        const formatted = numberToShow.toLocaleString('en');

        return `${formatted}${suffix}`;
    }

    render() {
        const { appearance, max, children, className, ...rest } = this.props;

        return (
            <span
                data-component="Badge"
                className={cx('sarsa-badge', appearance, className)}
                {...rest}>
                {this.renderFormattedNumber()}
            </span>
        );
    }
}